import { TabContext, TabList, TabPanel } from "@mui/lab"
import { Box, Tab } from "@mui/material"
import React, { useEffect, useState } from "react"
import { UMTabsList, UMTabsWrapper } from "./Atom"
import UsersTable from "../../Table/UsesTable"
import RolesTable from "../../Table/RolesAndPermissionsTable/RolesTable"
import PermissionsTable from "../../Table/RolesAndPermissionsTable/PermissionsTable"
import MetricGoalFooter from "../../Footers/MetricGoalsFooter"
import UserActivationConfirmation from "../../Modal/UserActivationConfirmation"
import PermsWrapper from "../../Auth/PermsWrapper"
import { permissions } from "../../../../config/constants"
import { useSelector } from "react-redux"

type UserManagementTabsProps = {
  fetchAllRolesAndPerms: any
  deactivateUser: any
  reactivateUser: any
}

const UserManagementTabs = (props: UserManagementTabsProps) => {
  const { fetchAllRolesAndPerms, deactivateUser, reactivateUser } = props

  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })

  const [valueTab, setValueTab] = useState("1")
  const [selectedUser, setSelectedUser] = useState<any>({})

  useEffect(() => {
    console.log("selectedUser", selectedUser)
  }, [selectedUser])
  const handleChangeTab = (
    event: React.SyntheticEvent,
    newValueTab: string,
  ) => {
    setValueTab(newValueTab)
  }

  const [open, setOpen] = useState<boolean>(false)
  const [type, setType] = useState<string>("")

  const handleUserActivationActionOpen = (row: any) => {
    const status = row?.original?.status

    setSelectedUser(row?.original)

    if (status == "inactive") {
      setType("reActivate")
    } else {
      setType("deActivate")
    }

    setOpen(true)
  }

  return (
    <UMTabsWrapper>
      <UserActivationConfirmation
        open={open}
        setOpen={setOpen}
        type={type}
        selectedUser={selectedUser}
        deactivateUser={deactivateUser}
        reactivateUser={reactivateUser}
      />
      <TabContext value={valueTab}>
        {allPerms?.includes(permissions?.VIEW_ROLES_PERMISSIONS) ? (
          <UMTabsList aria-label="UMTabs" onChange={handleChangeTab}>
            <Tab label="Users" value="1" disableRipple />
            <Tab label="Roles & Permissions" value="2" disableRipple />
          </UMTabsList>
        ) : (
          <UMTabsList aria-label="UMTabs" onChange={handleChangeTab}>
            <Tab label="Users" value="1" disableRipple />
          </UMTabsList>
        )}
        <TabPanel value="1">
          <UsersTable
            handleUserActivationActionOpen={handleUserActivationActionOpen}
          />
        </TabPanel>
        <TabPanel value="2" sx={{ height: "60vh", padding: 0 }}>
          <Box
            sx={{
              display: "flex",
              height: "100%",
              width: "100%",
              marginTop: "4px",
            }}
          >
            <RolesTable fetchAllRolesAndPerms={fetchAllRolesAndPerms} />
            <PermissionsTable />
          </Box>
          {/* <MetricGoalFooter /> */}
        </TabPanel>
      </TabContext>
    </UMTabsWrapper>
  )
}
export default UserManagementTabs
